import { Box, Collapse, TableCell } from '@/shared/ui';

import type { SymbolKey } from '@/entities/symbol';
import SymbolsPreview from '@/features/_shared/SymbolsPreview';
import type { CommoditiesTableRowType } from '@/features/markets/types';

const CollapsedRow = ({
  open,
  lastSymbol,
  diffSymbol,
  row,
  hideInfo = false
}: {
  open: boolean;
  lastSymbol: SymbolKey;
  diffSymbol: SymbolKey;
  row: CommoditiesTableRowType;
  hideInfo?: boolean;
}) => {
  return (
    <TableCell
      className='collapsed-table-row'
      colSpan={7}
      sx={theme => ({
        pb: 0,
        pt: 0,
        borderLeft: `2px solid ${open ? theme.palette.gx.highlight : 'transparent'}`
      })}
    >
      <Collapse
        in={open}
        timeout='auto'
      >
        <Box sx={{ ml: 3.5 }}>
          <SymbolsPreview
            hideInfo={hideInfo}
            enableQuery={open}
            stickyHeader={false}
            items={[
              {
                symbol: lastSymbol,
                label: 'Last',
                metadata: row.metadata,
                periodAbs: row.periodAbs
              },
              {
                symbol: diffSymbol,
                label: 'Diff',
                metadata: row.diffMetadata,
                periodAbs: row.diffPeriodAbs
              }
            ]}
          />
        </Box>
      </Collapse>
    </TableCell>
  );
};

export default CollapsedRow;
